import { screenNames } from "clientState/AuthFlow/providers/ScreenProvider/screenNames";

import type {
  GenericRenderScreenType,
  RenderScreenType,
  UpdateMultisessionType,
  UseScreenActionsType,
} from "./reducer/contract";
import { reducerTypes } from "./reducer/reducerTypes";
import { useScreenState } from "./ScreenProvider";

const { RENDER_SCREEN, TOGGLE_NEWSLETTER, UPDATE_MULTISESSION_TOKEN } =
  reducerTypes;

export const useScreenActions: UseScreenActionsType = () => {
  const { dispatch } = useScreenState();

  const { PASSWORDLESS, LOGIN_SYNC, SIGNIN, SIGNUP, FORGOT_PASSWORD, SUCCESS } =
    screenNames;

  const renderScreen: GenericRenderScreenType = (screen, userData) => {
    dispatch({
      type: RENDER_SCREEN,
      payload: { screen, userData },
    });
  };

  const renderPasswordlessScreen: RenderScreenType = (userData) => {
    renderScreen(PASSWORDLESS, userData);
  };

  const renderLoginSyncScreen: RenderScreenType = (userData) => {
    renderScreen(LOGIN_SYNC, userData);
  };

  const renderSigninScreen: RenderScreenType = (userData) => {
    renderScreen(SIGNIN, userData);
  };

  const renderSignupScreen: RenderScreenType = (userData) => {
    renderScreen(SIGNUP, userData);
  };

  const renderForgotPasswordScreen: RenderScreenType = (userData) => {
    renderScreen(FORGOT_PASSWORD, userData);
  };

  const renderSuccessScreen: RenderScreenType = (userData) => {
    renderScreen(SUCCESS, userData);
  };

  const toggleNewsletter = (): void => {
    dispatch({ type: TOGGLE_NEWSLETTER });
  };

  const updateMultisessionToken: UpdateMultisessionType = ({
    multiSessionToken,
  }): void => {
    dispatch({
      type: UPDATE_MULTISESSION_TOKEN,
      payload: {
        screen: LOGIN_SYNC,
        userData: { multiSessionToken: multiSessionToken },
      },
    });
  };

  return {
    renderScreen,
    renderPasswordlessScreen,
    renderLoginSyncScreen,
    renderSigninScreen,
    renderSignupScreen,
    renderForgotPasswordScreen,
    renderSuccessScreen,
    toggleNewsletter,
    updateMultisessionToken,
  };
};
